import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { SchemaElement, SchemaRegion } from "../../../api/restaurantSchema";
import { hasTrailingStar, isTableNameTaken } from "../../../components/restaurant-schema/tableNames";

/** Грешката за номер, преди да стигне до BE (422 „*", 409 зает). */
export const useTableNameError = (
  regions: SchemaRegion[],
  name: string,
  current: SchemaElement | null,
) => {
  const { t } = useTranslation();
  const trimmed = name.trim();
  // Старите маси с „*" не се мигрират — грешка само при ново име.
  if (!trimmed || trimmed === current?.name) return null;
  if (hasTrailingStar(trimmed)) return t("restaurantSchema.table.nameTrailingStar");
  if (isTableNameTaken(regions, trimmed, current?.id)) return t("restaurantSchema.table.nameTaken");
  return null;
};

/**
 * Номерът на избраната маса: пише се свободно и се записва при Enter/„Запази"
 * (не на всеки знак — 409 при зает/маса в употреба). Отказ от BE връща кеша
 * към стария номер → полето го следва. Esc връща записания номер.
 */
export const useTableNameDraft = (
  table: SchemaElement,
  regions: SchemaRegion[],
  onRename: (table: SchemaElement, name: string) => void,
) => {
  const [name, setName] = useState(table.name ?? "");
  useEffect(() => setName(table.name ?? ""), [table.name]);
  const error = useTableNameError(regions, name, table);

  const commit = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setName(table.name ?? "");
      return;
    }
    // С грешка не се праща — текстът остава, за да се поправи.
    if (error || trimmed === table.name) return;
    onRename(table, trimmed);
  };

  const cancel = () => setName(table.name ?? "");

  return { name, setName, error, commit, cancel };
};
